import { Vehicle } from '../types';
import { VehicleCard } from './VehicleCard';
import { Loader2 } from 'lucide-react';

interface VehicleGridProps {
  vehicles: Vehicle[];
  isLoading?: boolean;
}

export const VehicleGrid = ({ vehicles, isLoading = false }: VehicleGridProps) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-16 space-y-4">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <p className="text-muted-foreground animate-pulse">
          Chargement des véhicules disponibles...
        </p>
      </div>
    );
  }

  if (vehicles.length === 0) {
    return (
      <div className="text-center py-16 px-4">
        <div className="max-w-md mx-auto space-y-4">
          <div className="w-20 h-20 mx-auto bg-muted rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-foreground">Aucun véhicule disponible</h3>
          <p className="text-muted-foreground">
            Notre stock est actuellement vide, mais de nouveaux véhicules arrivent régulièrement. 
            Contactez-nous pour connaître nos prochaines disponibilités !
          </p>
        </div>
      </div>
    );
  }

  return (
    <div data-vehicles className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 animate-in fade-in duration-500">
      {vehicles.map((vehicle, index) => (
        <div 
          key={vehicle.id} 
          className="animate-in slide-in-from-bottom duration-500"
          style={{ animationDelay: `${index * 100}ms` }}
        >
          <VehicleCard vehicle={vehicle} />
        </div>
      ))}
    </div>
  );
};
